// Preferences.styles.ts
import styled from "styled-components";

// ===== INTERFACE DO TEMA =====
interface Theme {
  colors: {
    background: string;
    text: string;
    selection: string;
    modalColor: string;
    border: string;
    primary?: string;
    danger?: string;
    selectionDark?: string;
    textOnPrimary?: string;
    label?: string;
    borderColor?: string;
  };
}

// ===== COMPONENTES DE FORMULÁRIO =====
export const FieldsContainer = styled.div`
  width: 100%;
  max-width: 100%;
  height: 85%;
  max-height: 85%;
  padding: var(--sp-24);
  flex-direction: column;
  box-sizing: border-box;
  overflow: auto;

  &::-webkit-scrollbar {
    width: calc(var(--u) * 15);
    height: calc(var(--u) * 15);
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors.modalColor + "90"};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.colors.selection};
    border-radius: 10px;
    border: 2px solid ${(props) => props.theme.colors.modalColor + "90"};
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${(props) => props.theme.colors.selectionDark};
    cursor: grab;
  }

  &::-webkit-scrollbar-thumb:active {
    cursor: grabbing;
  }
  &:hover {
    scrollbar-width: auto;
  }
  scrollbar-color: ${(props) => props.theme.colors.selection};
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sp-8);
  width: 100%;

  label {
    font-weight: 600;
    font-size: var(--fs-md);
    color: ${(props) => props.theme.colors.text};
    display: flex;
    align-items: center;
    gap: var(--sp-8);
  }

  input,
  select,
  textarea {
    box-sizing: border-box;
    width: 100%;
  }
`;

// ===== COMPONENTES DE DADOS PESSOAIS =====
export const SectionTitle = styled.h3`
  font-size: var(--fs-xl);
  font-weight: 600;
  color: ${(props) => props.theme.colors.selection};
  margin: 0 0 var(--sp-16) 0;
  text-shadow: -0.5px -0.5px 0.5px black, 0.5px -0.5px 0.5px black,
    -0.5px 0.5px 0.5px black, 0.5px 0.5px 0.5px black;
`;

// Exportação padrão para compatibilidade
export default {
  FieldsContainer,
  InputWrapper,
  SectionTitle,
};
